// 小さな道具（$・reveal。el・keyOf は中身の core/util.ts にあり、ここからも使える）（2026-10-21 に app.js から分けた）
export { el, keyOf } from './core/util.js';

// ページの要素（page.php が置いている id。無いときは null だが、型では在るものとして扱う）
export function $<T extends HTMLElement = HTMLElement>(id: string): T { return document.getElementById(id) as T; }
export function setStatus(text: string) { const n = $('status'); if (n) n.textContent = text; }
// 「両方・左・右」の丸の色（i: 0 両方・1 左・2 右）。両方は左と右の半分ずつ（同じ色ならその色）。
// 左右の色（lr.ts）と左右でひと組（categories.ts）の両方がこれを使う（2026-10-28。前は別々に書いていて、ひと組だけ半分ずつになっていた）
export function sideDot(i: number, l: string, r: string) { return i === 1 ? l : i === 2 ? r : l === r ? l : 'linear-gradient(90deg,' + l + ' 50%,' + r + ' 50%)'; }
// 帯や一覧の中だけをスクロールして、node を見えるところへ（scrollIntoView はページごと動かすことがある）
// center: true は縦横ともまん中へ、'x' は横だけまん中へ（縦は見えるところまで）
export function reveal(box: Element, node: Element | null, center?: boolean | 'x') {
  if (!node) return;
  const b = box.getBoundingClientRect(), r = node.getBoundingClientRect();
  if (box.scrollHeight > box.clientHeight) {
    if (center === true) box.scrollTop += r.top - b.top - (b.height - r.height) / 2;
    else if (r.top < b.top) box.scrollTop += r.top - b.top;
    else if (r.bottom > b.bottom) box.scrollTop += r.bottom - b.bottom;
  }
  if (box.scrollWidth > box.clientWidth) {
    if (center) box.scrollLeft += r.left - b.left - (b.width - r.width) / 2;
    else if (r.left < b.left) box.scrollLeft += r.left - b.left;
    else if (r.right > b.right) box.scrollLeft += r.right - b.right;
  }
}
